/**
 * TICARI EKRANLAR — faturalar, abonelikler, fiyatlar
 *
 * Para hep KURUS tam sayisi olarak tasinir; ekranda bicimlenir. Kullanicidan
 * fiyat alirken de lira girilir, kurusa CEVRILEREK gonderilir — kullaniciya
 * "kurus gir" demek arayuzun isi degil.
 */
import { useState } from "react";
import {
  api,
  tarih,
  type Abonelik,
  type Fatura,
  type FaturaSatir,
  type Fiyat,
} from "../api";
import { Bildirim, Bos, Durum, Kart, Olcu, Rozet, Tablo, useCek } from "../ui";

export function para(kurus: number): string {
  const isaret = kurus < 0 ? "-" : "";
  const m = Math.abs(kurus);
  return `${isaret}${Math.floor(m / 100).toLocaleString("tr-TR")},${String(m % 100).padStart(2, "0")} ₺`;
}

/** "349,90" ya da "349.90" -> 34990 kurus. Bos deger null. */
function liraKurus(metin: string): number | null {
  const t = metin.trim().replace(/\s/g, "").replace(",", ".");
  if (!t) return null;
  const n = Number(t);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

function DurumRozet({ durum }: { durum: string }) {
  if (durum === "odendi") return <Rozet tur="iyi">ödendi</Rozet>;
  if (durum === "gecikti") return <Rozet tur="kotu">gecikti</Rozet>;
  if (durum === "bekliyor") return <Rozet tur="uyari">bekliyor</Rozet>;
  if (durum === "iptal") return <Rozet>iptal</Rozet>;
  if (durum === "deneme") return <Rozet tur="marka">deneme</Rozet>;
  if (durum === "aktif") return <Rozet tur="iyi">aktif</Rozet>;
  if (durum === "gecikmis") return <Rozet tur="kotu">gecikmiş</Rozet>;
  return <Rozet>{durum}</Rozet>;
}

// --------------------------------------------------------------- faturalar

export function Faturalar({ git, rol }: { git: (y: string) => void; rol: string }) {
  const liste = useCek(() => api.faturalar(), []);
  const [ekle, setEkle] = useState(false);
  const [mesaj, setMesaj] = useState<string | null>(null);
  const operator = rol === "operator";

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Faturalar</h1>
          <p>
            {operator
              ? "Kesilen faturalar, ödeme durumu ve açık bakiye. Ödeme işaretlendiğinde, ödeme gecikmesi yüzünden kilitlenmiş kutular otomatik açılır."
              : "Kurumunuza kesilen faturalar. PDF'i indirip ödeme bilgilerine ulaşabilirsiniz."}
          </p>
        </div>
        {operator && (
          <button className="dugme ana" onClick={() => setEkle((v) => !v)}>
            {ekle ? "Vazgeç" : "Elle fatura kes"}
          </button>
        )}
      </div>

      {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}
      {ekle && (
        <FaturaEkle
          kapat={() => setEkle(false)}
          bitti={(m) => {
            setEkle(false);
            setMesaj(m);
            liste.yenile();
          }}
        />
      )}

      <Durum cekim={liste}>
        {(y) => (
          <>
            <div className="izgara d4">
              <Olcu ad="Fatura" deger={y.ozet.adet} />
              <Olcu ad="Bekleyen" deger={y.ozet.bekleyen} />
              <Olcu ad="Geciken" deger={y.ozet.geciken} not={y.ozet.geciken ? "ödeme takibi gerekli" : undefined} />
              <Olcu ad="Açık bakiye" deger={para(y.ozet.acikBakiye)} />
            </div>

            <Kart baslik="Fatura listesi">
              {y.veri.length === 0 ? (
                <Bos>Henüz fatura kesilmedi.</Bos>
              ) : (
                <Tablo
                  basliklar={[
                    "No",
                    ...(operator ? ["Müşteri"] : []),
                    "Dönem",
                    "Kesim",
                    "Vade",
                    "#Tutar",
                    "Durum",
                    "",
                  ]}
                >
                  {y.veri.map((f) => (
                    <tr key={f.id}>
                      <td>
                        <a
                          href={"#/faturalar/" + f.id}
                          onClick={(e) => {
                            e.preventDefault();
                            git("/faturalar/" + f.id);
                          }}
                        >
                          <code>{f.no}</code>
                        </a>
                      </td>
                      {operator && <td>{f.musteriAdi}</td>}
                      <td>
                        <small>
                          {f.donem_bas} – {f.donem_bit}
                        </small>
                      </td>
                      <td>
                        <small>{f.kesim}</small>
                      </td>
                      <td>
                        <small>{f.vade}</small>
                        {f.gecikmeGun > 0 && <div className="not">{f.gecikmeGun} gün geçti</div>}
                      </td>
                      <td className="sayi">
                        <strong>{para(f.toplam_kurus)}</strong>
                      </td>
                      <td>
                        <DurumRozet durum={f.durum} />
                        {!f.otomatik && (
                          <>
                            {" "}
                            <Rozet>elle</Rozet>
                          </>
                        )}
                      </td>
                      <td>
                        {/* Duz <a href> Authorization basligi GONDERMEZ ve 401 doner;
                            PDF jetonla cekilip blob olarak indirilir. */}
                        <button className="dugme kucuk" onClick={() => api.faturaPdf(f.id, f.no)}>
                          PDF
                        </button>
                      </td>
                    </tr>
                  ))}
                </Tablo>
              )}
            </Kart>
          </>
        )}
      </Durum>
    </>
  );
}

function FaturaEkle({ kapat, bitti }: { kapat: () => void; bitti: (mesaj: string) => void }) {
  const musteriler = useCek(() => api.musteriler(), []);
  const [kiraciId, setKiraciId] = useState("");
  const [vadeGun, setVadeGun] = useState("14");
  const [satirlar, setSatirlar] = useState([{ aciklama: "", adet: "1", lira: "" }]);
  const [bekliyor, setBekliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  const cevrilen = satirlar.map((s) => ({ ...s, kurus: liraKurus(s.lira) }));
  const gecerli = kiraciId && cevrilen.every((s) => s.aciklama.trim() && s.kurus !== null);
  const ara = cevrilen.reduce((t, s) => t + (s.kurus ?? 0) * (Number(s.adet) || 0), 0);
  const kdv = Math.round(ara * 0.2);

  async function kaydet() {
    setBekliyor(true);
    setHata(null);
    try {
      const y = await api.faturaElle({
        kiraciId,
        vadeGun: Number(vadeGun) || 14,
        satirlar: cevrilen.map((s) => ({
          aciklama: s.aciklama.trim(),
          adet: Number(s.adet) || 1,
          birimKurus: s.kurus!,
        })),
      });
      bitti(`${y.veri.no} kesildi — ${para(y.veri.toplam_kurus)}`);
    } catch (e: any) {
      setHata(e?.message ?? "Fatura kesilemedi");
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Kart baslik="Elle fatura">
      {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
      <div className="izgara d2">
        <label className="alan">
          <span>Müşteri</span>
          <select value={kiraciId} onChange={(e) => setKiraciId(e.target.value)}>
            <option value="">seçin…</option>
            {(musteriler.veri?.veri ?? []).map((m) => (
              <option key={m.id} value={m.id}>
                {m.ad}
              </option>
            ))}
          </select>
        </label>
        <label className="alan">
          <span>Vade (gün)</span>
          <input value={vadeGun} onChange={(e) => setVadeGun(e.target.value.replace(/\D/g, ""))} inputMode="numeric" />
        </label>
      </div>

      <Tablo basliklar={["Açıklama", "#Adet", "#Birim (₺)", "#Tutar", ""]}>
        {satirlar.map((s, i) => {
          const k = liraKurus(s.lira);
          return (
            <tr key={i}>
              <td>
                <input
                  value={s.aciklama}
                  placeholder="Kurulum bedeli, ek posta kutusu…"
                  onChange={(e) =>
                    setSatirlar(satirlar.map((x, j) => (i === j ? { ...x, aciklama: e.target.value } : x)))
                  }
                  style={{ width: "100%" }}
                />
              </td>
              <td className="sayi">
                <input
                  value={s.adet}
                  inputMode="numeric"
                  onChange={(e) =>
                    setSatirlar(satirlar.map((x, j) => (i === j ? { ...x, adet: e.target.value.replace(/\D/g, "") } : x)))
                  }
                  style={{ width: 64, textAlign: "right" }}
                />
              </td>
              <td className="sayi">
                <input
                  value={s.lira}
                  placeholder="500,00"
                  inputMode="decimal"
                  onChange={(e) => setSatirlar(satirlar.map((x, j) => (i === j ? { ...x, lira: e.target.value } : x)))}
                  style={{ width: 110, textAlign: "right" }}
                />
              </td>
              <td className="sayi">{k === null ? "—" : para(k * (Number(s.adet) || 0))}</td>
              <td>
                {satirlar.length > 1 && (
                  <button className="dugme kucuk" onClick={() => setSatirlar(satirlar.filter((_, j) => j !== i))}>
                    sil
                  </button>
                )}
              </td>
            </tr>
          );
        })}
      </Tablo>

      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap", alignItems: "center" }}>
        <button className="dugme kucuk" onClick={() => setSatirlar([...satirlar, { aciklama: "", adet: "1", lira: "" }])}>
          + satır
        </button>
        <div style={{ flex: 1 }} />
        <small>
          Ara toplam <strong>{para(ara)}</strong> · KDV %20 <strong>{para(kdv)}</strong> · Genel toplam{" "}
          <strong>{para(ara + kdv)}</strong>
        </small>
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <button className="dugme" onClick={kapat}>
          Vazgeç
        </button>
        <button className="dugme ana" onClick={kaydet} disabled={!gecerli || bekliyor}>
          {bekliyor ? "Kesiliyor…" : "Faturayı kes"}
        </button>
      </div>
    </Kart>
  );
}

// --------------------------------------------------------------- fatura detay

export function FaturaDetay({ id, git, rol }: { id: string; git: (y: string) => void; rol: string }) {
  const cekim = useCek(() => api.fatura(Number(id)), [id]);
  const [bekliyor, setBekliyor] = useState(false);
  const [mesaj, setMesaj] = useState<string | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [yontem, setYontem] = useState("havale");
  const operator = rol === "operator";

  async function calistir(f: () => Promise<{ mesaj?: string }>) {
    setBekliyor(true);
    setHata(null);
    try {
      const y = await f();
      setMesaj(y.mesaj ?? "İşlem tamam");
      cekim.yenile();
    } catch (e: any) {
      setHata(e?.message ?? "İşlem yapılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Durum cekim={cekim}>
      {(y) => {
        const f = y.veri;
        return (
          <>
            <div className="baslik">
              <div>
                <p>
                  <a
                    href="#/faturalar"
                    onClick={(e) => {
                      e.preventDefault();
                      git("/faturalar");
                    }}
                  >
                    ← Faturalar
                  </a>
                </p>
                <h1>
                  <code>{f.no}</code> <DurumRozet durum={f.durum} />
                </h1>
                <p>
                  {y.musteriAdi} · {f.donem_bas} – {f.donem_bit}
                </p>
              </div>
              <button className="dugme" onClick={() => api.faturaPdf(f.id, f.no)}>
                PDF indir
              </button>
            </div>

            {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}
            {hata && <Bildirim tur="kotu">{hata}</Bildirim>}

            {f.durum === "gecikti" && (
              <Bildirim tur="kotu">
                Bu faturanın vadesi {f.vade} tarihinde doldu. Tolerans süresi de dolduğunda müşterinin
                kutuları otomatik olarak kilitlenir; gelen posta kabul edilmeye devam eder.
              </Bildirim>
            )}

            <Kart baslik="Kalemler">
              <Tablo basliklar={["Açıklama", "#Adet", "#Birim", "#Tutar"]}>
                {y.satirlar.map((s: FaturaSatir, i: number) => (
                  <tr key={i}>
                    <td style={{ whiteSpace: "pre-line" }}>{s.aciklama}</td>
                    <td className="sayi">{s.adet}</td>
                    <td className="sayi">{para(s.birim_kurus)}</td>
                    <td className="sayi">
                      <strong>{para(s.tutar_kurus)}</strong>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={3} className="sayi">
                    Ara toplam
                  </td>
                  <td className="sayi">{para(f.ara_toplam_kurus)}</td>
                </tr>
                <tr>
                  <td colSpan={3} className="sayi">
                    KDV (%{f.kdv_oran})
                  </td>
                  <td className="sayi">{para(f.kdv_kurus)}</td>
                </tr>
                <tr>
                  <td colSpan={3} className="sayi">
                    <strong>Genel toplam</strong>
                  </td>
                  <td className="sayi">
                    <strong>{para(f.toplam_kurus)}</strong>
                  </td>
                </tr>
              </Tablo>
            </Kart>

            <div className="izgara d4">
              <Olcu ad="Kesim" deger={f.kesim} />
              <Olcu ad="Son ödeme" deger={f.vade} />
              {f.odeme_zamani && <Olcu ad="Ödeme" deger={tarih(f.odeme_zamani)} not={f.odeme_yontemi ?? undefined} />}
            </div>

            {y.odeme && f.durum !== "odendi" && f.durum !== "iptal" && (
              <Kart baslik="Ödeme bilgileri">
                <dl className="ikili">
                  <dt>Unvan</dt>
                  <dd>{y.odeme.unvan}</dd>
                  <dt>Banka</dt>
                  <dd>{y.odeme.banka}</dd>
                  <dt>IBAN</dt>
                  <dd>
                    <code>{y.odeme.iban}</code>
                  </dd>
                  <dt>Açıklama</dt>
                  <dd>
                    <code>{f.no}</code>
                  </dd>
                </dl>
                <small>Açıklamaya fatura numarasını yazmanız ödemenin eşleşmesini hızlandırır.</small>
              </Kart>
            )}

            {operator && f.durum !== "iptal" && (
              <Kart baslik="Operatör işlemleri">
                {f.durum !== "odendi" ? (
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                    <select value={yontem} onChange={(e) => setYontem(e.target.value)}>
                      <option value="havale">havale / EFT</option>
                      <option value="nakit">nakit</option>
                      <option value="kredi karti">kredi kartı</option>
                      <option value="mahsup">mahsup</option>
                    </select>
                    <button
                      className="dugme ana"
                      disabled={bekliyor}
                      onClick={() => calistir(() => api.faturaOdendi(f.id, yontem))}
                    >
                      Ödendi olarak işaretle
                    </button>
                    <button
                      className="dugme tehlike"
                      disabled={bekliyor}
                      onClick={() => {
                        if (confirm(`${f.no} iptal edilsin mi? Bu işlem geri alınamaz.`)) {
                          calistir(() => api.faturaIptal(f.id).then(() => ({ mesaj: "Fatura iptal edildi." })));
                        }
                      }}
                    >
                      Faturayı iptal et
                    </button>
                  </div>
                ) : (
                  <Bildirim tur="iyi">
                    Bu fatura {tarih(f.odeme_zamani)} tarihinde {f.odeme_yontemi} olarak tahsil edilmiş.
                    Ödenmiş fatura iptal edilemez; gerekiyorsa düzeltme faturası kesin.
                  </Bildirim>
                )}
              </Kart>
            )}
          </>
        );
      }}
    </Durum>
  );
}

// --------------------------------------------------------------- abonelikler

export function Abonelikler({ git }: { git: (y: string) => void }) {
  const cekim = useCek(() => api.abonelikler(), []);
  const [bekliyor, setBekliyor] = useState(false);
  const [sonuc, setSonuc] = useState<string[] | null>(null);
  const [hata, setHata] = useState<string | null>(null);

  async function dongu() {
    setBekliyor(true);
    setHata(null);
    try {
      const y = await api.faturaDongu();
      const s = [
        `${y.veri.incelenen} abonelik incelendi`,
        ...y.veri.kesilen.map((x) => "Fatura: " + x),
        ...y.veri.gecikenler.map((x) => "Gecikti: " + x),
        ...y.veri.askiyaAlinan.map((x) => "Askıya alındı: " + x),
        ...y.veri.hata.map((x) => "Hata: " + x),
      ];
      setSonuc(s.length > 1 ? s : [...s, "Yapılacak bir şey yoktu."]);
      cekim.yenile();
    } catch (e: any) {
      setHata(e?.message ?? "Döngü çalıştırılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Abonelikler</h1>
          <p>
            Fatura döngüsü her gün 06:20'de kendiliğinden çalışır. Buradaki düğme aynı işi hemen
            yapar; vadesi gelenleri faturalar, gecikenleri işaretler, toleransı da geçen müşteriyi
            askıya alır.
          </p>
        </div>
        <button className="dugme ana" onClick={dongu} disabled={bekliyor}>
          {bekliyor ? "Çalışıyor…" : "Döngüyü şimdi çalıştır"}
        </button>
      </div>

      {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
      {sonuc && (
        <Bildirim tur="iyi">
          {sonuc.map((s, i) => (
            <div key={i}>{s}</div>
          ))}
        </Bildirim>
      )}

      <Durum cekim={cekim}>
        {(y) => (
          <>
            <div className="izgara d4">
              <Olcu ad="Abonelik" deger={y.ozet.toplam} />
              <Olcu ad="Denemede" deger={y.ozet.deneme} />
              <Olcu ad="Gecikmiş" deger={y.ozet.gecikmis} />
              <Olcu ad="Açık bakiye" deger={para(y.ozet.acikBakiye)} />
            </div>

            <Kart baslik="Abonelikler">
              {y.veri.length === 0 ? (
                <Bos>Abonelik yok.</Bos>
              ) : (
                <Tablo
                  basliklar={["Müşteri", "Paket", "Dönem", "Durum", "Sonraki fatura", "Vade", "#Açık bakiye"]}
                >
                  {y.veri.map((a) => (
                    <tr key={a.kiraci_id}>
                      <td>
                        <a
                          href={"#/musteriler/" + a.kiraci_id}
                          onClick={(e) => {
                            e.preventDefault();
                            git("/musteriler/" + a.kiraci_id);
                          }}
                        >
                          {a.musteriAdi}
                        </a>
                      </td>
                      <td>
                        <Rozet tur="marka">{a.paket}</Rozet>
                      </td>
                      <td>{a.donem === "yillik" ? "yıllık" : "aylık"}</td>
                      <td>
                        <DurumRozet durum={a.durum} />
                      </td>
                      <td>
                        <small>{a.sonraki_fatura}</small>
                        {a.deneme_bitis && a.durum === "deneme" && (
                          <div className="not">deneme {a.deneme_bitis} bitiyor</div>
                        )}
                      </td>
                      <td>
                        <small>
                          {a.vade_gun} gün · tolerans {a.tolerans_gun}
                        </small>
                      </td>
                      <td className="sayi">
                        {a.acikBakiye > 0 ? <strong>{para(a.acikBakiye)}</strong> : "—"}
                      </td>
                    </tr>
                  ))}
                </Tablo>
              )}
            </Kart>
          </>
        )}
      </Durum>
    </>
  );
}

// --------------------------------------------------------------- fiyatlar

export function Fiyatlar() {
  const cekim = useCek(() => api.fiyatlar(), []);
  const [duzen, setDuzen] = useState<Record<string, { aylik: string; yillik: string }>>({});
  const [bekliyor, setBekliyor] = useState<string | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [mesaj, setMesaj] = useState<string | null>(null);

  async function kaydet(paket: string, f: Fiyat) {
    const d = duzen[paket];
    const aylik = d ? liraKurus(d.aylik) : f.aylik_kurus;
    const yillik = d ? liraKurus(d.yillik) : f.yillik_kurus;
    if (aylik === null || yillik === null) {
      setHata("Fiyat sayı olmalı (örnek: 349,00)");
      return;
    }
    setBekliyor(paket);
    setHata(null);
    try {
      await api.fiyatYaz(paket, aylik, yillik);
      setMesaj(`${paket} fiyatı güncellendi.`);
      setDuzen({ ...duzen, [paket]: undefined as any });
      cekim.yenile();
    } catch (e: any) {
      setHata(e?.message ?? "Kaydedilemedi");
    } finally {
      setBekliyor(null);
    }
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Fiyatlar</h1>
          <p>
            Paket fiyatları KDV hariçtir; faturada %20 KDV eklenir. Fiyat değişikliği geçmiş
            faturaları etkilemez, bir sonraki dönemden itibaren geçerlidir.
          </p>
        </div>
      </div>

      {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
      {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}

      <Durum cekim={cekim}>
        {(y) => (
          <Kart baslik="Paketler">
            <Tablo basliklar={["Paket", "İçerik", "#Aylık (₺)", "#Yıllık (₺)", "#KDV'li aylık", ""]}>
              {y.veri.map((f) => {
                const d = duzen[f.paket];
                const p = f.paketDetay;
                return (
                  <tr key={f.paket}>
                    <td>
                      <strong>{f.paket}</strong>
                    </td>
                    <td>
                      <small>
                        {p
                          ? `${p.kutu ?? "∞"} kutu · ${p.diskMb ? p.diskMb + " MB" : "∞"} disk · ` +
                            `${p.gunlukAlici.toLocaleString("tr-TR")} alıcı/gün · ${p.alanAdi ?? "∞"} alan adı`
                          : "—"}
                      </small>
                    </td>
                    <td className="sayi">
                      <input
                        value={d ? d.aylik : (f.aylik_kurus / 100).toFixed(2).replace(".", ",")}
                        inputMode="decimal"
                        onChange={(e) =>
                          setDuzen({
                            ...duzen,
                            [f.paket]: {
                              aylik: e.target.value,
                              yillik: d?.yillik ?? (f.yillik_kurus / 100).toFixed(2).replace(".", ","),
                            },
                          })
                        }
                        style={{ width: 110, textAlign: "right" }}
                      />
                    </td>
                    <td className="sayi">
                      <input
                        value={d ? d.yillik : (f.yillik_kurus / 100).toFixed(2).replace(".", ",")}
                        inputMode="decimal"
                        onChange={(e) =>
                          setDuzen({
                            ...duzen,
                            [f.paket]: {
                              aylik: d?.aylik ?? (f.aylik_kurus / 100).toFixed(2).replace(".", ","),
                              yillik: e.target.value,
                            },
                          })
                        }
                        style={{ width: 110, textAlign: "right" }}
                      />
                    </td>
                    <td className="sayi">
                      <small>{para(Math.round(f.aylik_kurus * 1.2))}</small>
                    </td>
                    <td>
                      <button
                        className="dugme kucuk"
                        disabled={!d || bekliyor === f.paket}
                        onClick={() => kaydet(f.paket, f)}
                      >
                        {bekliyor === f.paket ? "…" : "kaydet"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </Tablo>
            <small style={{ display: "block", marginTop: 10 }}>
              Yıllık fiyat varsayılan olarak on aylık bedeldir (iki ay hediye). İstediğiniz gibi
              değiştirebilirsiniz.
            </small>
          </Kart>
        )}
      </Durum>
    </>
  );
}

// --------------------------------------------------------------- musteri karti

/** Musteri ayrintisina gomulen abonelik bolumu */
export function AbonelikKarti({ kiraciId }: { kiraciId: string }) {
  const cekim = useCek(() => api.abonelik(kiraciId), [kiraciId]);
  const faturalar = useCek(() => api.faturalar(kiraciId), [kiraciId]);
  const [duzen, setDuzen] = useState(false);
  const [form, setForm] = useState<Partial<Abonelik>>({});
  const [bekliyor, setBekliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  async function kaydet() {
    setBekliyor(true);
    setHata(null);
    try {
      await api.abonelikGuncelle(kiraciId, form);
      setDuzen(false);
      cekim.yenile();
    } catch (e: any) {
      setHata(e?.message ?? "Kaydedilemedi");
    } finally {
      setBekliyor(false);
    }
  }

  if (cekim.hata && cekim.hata.durum === 404) {
    return (
      <Kart baslik="Abonelik">
        <Bildirim tur="uyari">
          Bu müşterinin abonelik kaydı yok, dolayısıyla faturalanmıyor. Aşağıdaki düğme aboneliği
          başlatır; ilk fatura bir sonraki dönemde kesilir.
        </Bildirim>
        <button
          className="dugme ana"
          disabled={bekliyor}
          onClick={async () => {
            setBekliyor(true);
            try {
              await api.abonelikGuncelle(kiraciId, { durum: "aktif" });
              cekim.yenile();
            } finally {
              setBekliyor(false);
            }
          }}
        >
          Aboneliği başlat
        </button>
      </Kart>
    );
  }

  return (
    <Durum cekim={cekim}>
      {(y) => {
        const a = y.veri;
        return (
          <Kart
            baslik="Abonelik ve faturalama"
            eylem={
              <button className="dugme kucuk" onClick={() => { setForm(a); setDuzen((v) => !v); }}>
                {duzen ? "vazgeç" : "düzenle"}
              </button>
            }
          >
            {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
            {duzen ? (
              <>
                <div className="izgara d2">
                  <label className="alan">
                    <span>Dönem</span>
                    <select
                      value={form.donem ?? a.donem}
                      onChange={(e) => setForm({ ...form, donem: e.target.value as any })}
                    >
                      <option value="aylik">aylık</option>
                      <option value="yillik">yıllık</option>
                    </select>
                  </label>
                  <label className="alan">
                    <span>Durum</span>
                    <select
                      value={form.durum ?? a.durum}
                      onChange={(e) => setForm({ ...form, durum: e.target.value as any })}
                    >
                      <option value="deneme">deneme</option>
                      <option value="aktif">aktif</option>
                      <option value="gecikmis">gecikmiş</option>
                      <option value="iptal">iptal</option>
                    </select>
                  </label>
                  <label className="alan">
                    <span>Sonraki fatura</span>
                    <input
                      type="date"
                      value={form.sonraki_fatura ?? a.sonraki_fatura}
                      onChange={(e) => setForm({ ...form, sonraki_fatura: e.target.value })}
                    />
                  </label>
                  <label className="alan">
                    <span>Vade (gün)</span>
                    <input
                      value={String(form.vade_gun ?? a.vade_gun)}
                      inputMode="numeric"
                      onChange={(e) => setForm({ ...form, vade_gun: Number(e.target.value.replace(/\D/g, "")) })}
                    />
                  </label>
                  <label className="alan">
                    <span>Askıya alma toleransı (gün)</span>
                    <input
                      value={String(form.tolerans_gun ?? a.tolerans_gun)}
                      inputMode="numeric"
                      onChange={(e) => setForm({ ...form, tolerans_gun: Number(e.target.value.replace(/\D/g, "")) })}
                    />
                  </label>
                  <label className="alan">
                    <span>Fatura unvanı</span>
                    <input
                      value={form.fatura_unvan ?? a.fatura_unvan ?? ""}
                      onChange={(e) => setForm({ ...form, fatura_unvan: e.target.value })}
                    />
                  </label>
                  <label className="alan">
                    <span>Vergi dairesi</span>
                    <input
                      value={form.vergi_dairesi ?? a.vergi_dairesi ?? ""}
                      onChange={(e) => setForm({ ...form, vergi_dairesi: e.target.value })}
                    />
                  </label>
                  <label className="alan">
                    <span>Vergi / TC no</span>
                    <input
                      value={form.vergi_no ?? a.vergi_no ?? ""}
                      onChange={(e) => setForm({ ...form, vergi_no: e.target.value })}
                    />
                  </label>
                </div>
                <label className="alan">
                  <span>Fatura adresi</span>
                  <textarea
                    rows={2}
                    value={form.fatura_adres ?? a.fatura_adres ?? ""}
                    onChange={(e) => setForm({ ...form, fatura_adres: e.target.value })}
                  />
                </label>
                <button className="dugme ana" onClick={kaydet} disabled={bekliyor} style={{ marginTop: 10 }}>
                  {bekliyor ? "Kaydediliyor…" : "Kaydet"}
                </button>
              </>
            ) : (
              <>
                <dl className="ikili">
                  <dt>Durum</dt>
                  <dd>
                    <DurumRozet durum={a.durum} />
                  </dd>
                  <dt>Paket / dönem</dt>
                  <dd>
                    {a.paket} · {a.donem === "yillik" ? "yıllık" : "aylık"} · {para(y.donemTutari)} + KDV
                  </dd>
                  <dt>Sonraki fatura</dt>
                  <dd>{a.sonraki_fatura}</dd>
                  {a.deneme_bitis && (
                    <>
                      <dt>Deneme bitişi</dt>
                      <dd>{a.deneme_bitis}</dd>
                    </>
                  )}
                  <dt>Vade / tolerans</dt>
                  <dd>
                    {a.vade_gun} gün / {a.tolerans_gun} gün
                  </dd>
                  <dt>Açık bakiye</dt>
                  <dd>{y.acikBakiye > 0 ? <strong>{para(y.acikBakiye)}</strong> : "yok"}</dd>
                  {a.fatura_unvan && (
                    <>
                      <dt>Fatura unvanı</dt>
                      <dd>{a.fatura_unvan}</dd>
                    </>
                  )}
                  {a.vergi_no && (
                    <>
                      <dt>Vergi no</dt>
                      <dd>
                        {a.vergi_dairesi} {a.vergi_no}
                      </dd>
                    </>
                  )}
                </dl>

                <Tablo basliklar={["Son faturalar", "Vade", "#Tutar", "Durum"]}>
                  {(faturalar.veri?.veri ?? []).slice(0, 5).map((f: Fatura) => (
                    <tr key={f.id}>
                      <td>
                        <a href={"#/faturalar/" + f.id}>
                          <code>{f.no}</code>
                        </a>
                      </td>
                      <td>
                        <small>{f.vade}</small>
                      </td>
                      <td className="sayi">{para(f.toplam_kurus)}</td>
                      <td>
                        <DurumRozet durum={f.durum} />
                      </td>
                    </tr>
                  ))}
                </Tablo>
                {(faturalar.veri?.veri.length ?? 0) === 0 && <Bos>Henüz fatura kesilmedi.</Bos>}
              </>
            )}
          </Kart>
        );
      }}
    </Durum>
  );
}
